<div *ngIf="initialDataStateService.aztecScannedCompletedActionInfoVisible"
     class="initial-data-section__completed-action-info initial-data-section__completed-action-info--aztec">
    <app-completed-action-info [leftContent]="aztecScannedCompletedActionInfoLeftContent"
                               (buttonClick)="initialDataStateService.scan()"
                               [data]="aztecScannedCompletedActionInfoData">
    </app-completed-action-info>
</div>

<app-section #parentSection
             [title]="title"
             *ngIf="sectionVisible"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [key]="key"
             class="initial-data-section"
             [ngClass]="{
                'initial-data-section--sections-below': sectionsBellow,
                'initial-data-section--unknown-registration-number-hint-visible': unknownRegistrationNumberHintVisible
             }"
             [formConfig]="formConfig"
             [editMode]="true">

    <ng-template #section>

        <app-section-data-presentation *ngIf="previewMode"
                                       [parentSection]="parentSection"
                                       [formGroup]="formGroup"
                                       [formConfig]="formConfig"
                                       [displayedFields]="dataPresentationFields">
        </app-section-data-presentation>

        <div class="initial-data-section__fields">
            <div *ngIf="registrationNumberVisible && canFieldDisplayed(SectionFieldKey.REGISTRATION_NUMBER)"
                 class="col initial-data-section__registration-number"
                 [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component col-50">
                    <app-text-field [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[SectionFieldKey.REGISTRATION_NUMBER]"
                                    [fieldConfig]="formFactoryService.fieldConfig(SectionFieldKey.REGISTRATION_NUMBER, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(SectionFieldKey.REGISTRATION_NUMBER)]"
                                    (markAsDirty)="markAsDirty($event)"
                                    (changeEvent)="initialDataStateService.registrationNumberChangeEvent($event)"
                                    (click)="registrationNumberClick()"
                    >
                    </app-text-field>
                </div>
                <div *ngIf="unknownRegistrationNumberVisible"
                     class="section__component col-50 initial-data-section__registration-number__unknown-number">
                    <app-checkbox [control]="formGroup.controls[SectionFieldKey.UNKNOWN_REGISTRATION_NUMBER]"
                                  [bean]="bean"
                                  [fieldConfig]="getFieldConfig(SectionFieldKey.UNKNOWN_REGISTRATION_NUMBER)"
                                  [errorsMap]="formFactoryService.errorsMap">
                    </app-checkbox>
                    <app-hint
                            *ngIf="initialDataStateService.unknownRegistrationNumber"
                            class="initial-data-section__registration-number__unknown-number__hint"
                            [content]="'INITIAL_DATA_SECTION.unknownRegistrationNumberHint'"
                            [arrowUp]="true">
                    </app-hint>
                </div>
            </div>

            <div *ngIf="birthDateVisible && canFieldDisplayed(SectionFieldKey.BIRTH_DATE)"
                 class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component col-50 datepicker-component initial-data-section__birth-date">
                    <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                             [control]="formGroup.controls[SectionFieldKey.BIRTH_DATE]"
                                             [fieldConfig]="formFactoryService.fieldConfig(SectionFieldKey.BIRTH_DATE, formConfig)"
                                             [context]="formConfig.formKey"
                                             [isDirtyBean]="isDirtyBean && isDirtyBean[SectionFieldKey.BIRTH_DATE]"
                                             (markAsDirty)="markAsDirty($event)"
                    ></app-material-datepicker>
                </div>
            </div>
        </div>

        <div *ngIf="initialDataStateService.footerVisible"
             class="initial-data-section__footer">
            <div [innerHTML]="'INITIAL_DATA_SECTION.footer' | translate | safeHtml"></div>
        </div>

    </ng-template>
</app-section>

<div *ngIf="initialDataStateService.aztecScannerInfoVisible"
     [ngClass]="{
        'initial-data-section__aztec-scanner-info--diagnostic-station': initialDataStateService.diagnosticStationScanView
    }"
     class="initial-data-section__aztec-scanner-info">
    <app-aztec-scanner-info [sectionsBellow]="sectionsBellow"
                            (openAztecScanner)="initialDataStateService.openAztecScanner()">
    </app-aztec-scanner-info>
</div>

<div *ngIf="initialDataStateService.aztecScannerActive"
     class="initial-data-section__aztec-scanner">
    <app-next-aztec-scanner (close)="initialDataStateService.closeAztecScanner($event)">
    </app-next-aztec-scanner>
</div>

<div *ngIf="initialDataStateService.diagnosticStationProcessInfoVisible"
     class="initial-data-section__diagnostic-station-process-info">
    <app-aztec-process-info></app-aztec-process-info>

    <app-next-other-products [title]="'AZTEC_PROCESS_INFO.productsTitle'"
                             [theme]="OtherProductsTheme.WHITE">
    </app-next-other-products>
</div>

<div *ngIf="initialDataStateService.scanClientAgreementButtonVisible"
     class="initial-data-section__scan-customer-agreement-btn">
    <button class="btn btn--secondary btn--big"
            (click)="scanCustomerAgreement()">
        {{ 'INITIAL_DATA_SECTION.scanCustomerAgreement' | translate }}
    </button>
</div>

<div *ngIf="initialDataStateService.customerAgreementScanningMode"
     class="initial-data-section__customer-agreement-capture">
    <app-customer-agreement-capture (result)="initialDataStateService.onCustomerAgreementCaptureResult($event)"></app-customer-agreement-capture>
</div>

<div *ngIf="initialDataStateService.customerAgreementPhotoCompletedActionInfoVisible"
     class="initial-data-section__completed-action-info initial-data-section__completed-action-info--photo">
    <app-completed-action-info [leftContent]="customerAgreementPhotoCompletedActionInfoLeftContent"
                               (buttonClick)="scanCustomerAgreement()"
                               [data]="customerAgreementPhotoCompletedActionInfoData">
    </app-completed-action-info>
</div>

<ng-template #aztecScannedCompletedActionInfoLeftContent>
    <div class="initial-data-section__completed-action-info__icon">
        <span class="material-icons">check</span>
    </div>
</ng-template>

<ng-template #customerAgreementPhotoCompletedActionInfoLeftContent>
    <div class="initial-data-section__completed-action-info__photo"
         (click)="initialDataStateService.openCustomerAgreementPhotoPreview()">
        <img [src]="initialDataStateService.customerAgreementPhoto" alt="">
    </div>
</ng-template>
